import { useDevTools } from '@src/types/constants'
import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import LoanCalendarPage from './LoanCalendarPage'
import { default as LoanCreatePage } from './LoanCreatePage'
import LoanListPage from './LoanListPage'

const LoanDetailRouter = () => {
  const { id, financingProgramId } = useParams()

  return (
    <Routes>
      <Route path="calendar" element={<LoanCalendarPage id={id!} financingProgramId={financingProgramId!} />} />
      <Route path="*" element={<Navigate to="../.." replace />} />
    </Routes>
  )
}

const LoansRouter = () => {
  return (
    <Routes>
      <Route path=":financingProgramId/:id/*" element={<LoanDetailRouter />} />
      {useDevTools && <Route path="create" element={<LoanCreatePage />} />}
      <Route path="" element={<LoanListPage />} />
      <Route path="*" element={<Navigate to=".." replace />} />
    </Routes>
  )
}

export default LoansRouter
